import React from 'react';
import { BonusesSection, FAQSection, Guarantee, Pain, ProductOverview, Results, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-accent selection:text-white" data-id="element-0" data-mp="2riklx1c3g39f">
      <MetaPixel data-id="element-1" data-mp="31b8ko1mmwhas" />
      <TopBar data-id="element-2" data-mp="31bs0ncsq4vm6" />
      <main data-id="element-3" data-mp="31c9w477kb5t1">
        <Hero data-id="element-4" data-mp="31c1iue7j1yhb" />
        <Testimonials data-id="element-5" data-mp="31cjog1g2xp1w" />
        <Pain data-id="element-6" data-mp="2wk9xqj754kyk" />
        <ProductOverview data-id="element-7" data-mp="2wjqft2hhpwkj" />
        <BonusesSection data-id="element-8" data-mp="2wifgbev2vaz8" />
        <Pricing data-id="element-9" data-mp="2wi5mthatqlos" />
        <Results data-id="element-10" data-mp="28u5yeo0zj7dd" />
        <Guarantee data-id="element-11" data-mp="28tmfb3zlmcxr" />
        <FAQSection data-id="element-12" data-mp="28t4lsf4bmctj" />
      </main>
      <Footer data-id="element-13" data-mp="28sbend1g9lav" />
      <FloatingElements data-id="element-14" data-mp="23vchsmqej08z" />
      <noscript data-id="element-15" data-mp="23w4gi6fape3h">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-16" data-mp="23ujkecdc1n3i" />
      </noscript>
    </div>;
}